import { render, staticRenderFns } from "./wtPlayerVideo.component.vue?vue&type=template&id=4673ea18&"
import script from "./wtPlayerVideo.component.vue?vue&type=script&lang=js&"
export * from "./wtPlayerVideo.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports